import { useState } from "react";
import { IShopingCart } from "../interfaces/shopping-cart.interface";
import { IShopingCartProduct } from "../interfaces/shopping-cart-product.interface";
import { IBuildingSiteListViewDto } from "../interfaces/building-site-list-view.interface";
import { CartOrderFormViewModel } from "../../../containers/shopping-cart-container/cart-order-form/cart-order-form-view.model";
import { IBuildingSiteAddressListView } from "../interfaces/building-site-address-list-view.interface";
import { IBuyerContactListView } from "../interfaces/buyer-contact-list-view.interface";

export const ShoppingCartUseBetween = () => {
  const [quantityShoppingCart, setQuantityShoppingCart] = useState<number>(0);
  const [shoppingCart, setShoppingCart] = useState<IShopingCart>({products: [] as IShopingCartProduct[]} as IShopingCart);
  const [buildingSite, setBuildingSite] = useState<IBuildingSiteListViewDto>();
  const [buildingSiteAddress, setBuildingSiteAddress] = useState<IBuildingSiteAddressListView>();
  const [buyerContact, setBuyerContact] = useState<IBuyerContactListView>();
  const [isReadyToOrder, setIsReadyToOrder] = useState<boolean>();
  const [isSelfPickup, setIsSelfPickup] = useState<boolean>(false);
  const [initialFormValues, setInitialFormValues] = useState<CartOrderFormViewModel>(new CartOrderFormViewModel());
  return {
    quantityShoppingCart,
    setQuantityShoppingCart,
    shoppingCart,
    setShoppingCart,
    buildingSite,
    setBuildingSite,
    isReadyToOrder,
    setIsReadyToOrder,
    initialFormValues,
    setInitialFormValues,
    isSelfPickup,
    setIsSelfPickup,
    buildingSiteAddress,
    setBuildingSiteAddress,
    buyerContact,
    setBuyerContact
  }
}